import { getContext, isContextAvailable } from '@/miniappContext';

export const NotificationType = {
  generationSuccess: 'generationSuccess',
  generationError: 'generationError',
  networkError: 'networkError',
  uploadError: 'uploadError',
} as const;

export type NotificationType = typeof NotificationType[keyof typeof NotificationType];

const NotificationConfigs: Record<NotificationType, { title: string; type: 'success' | 'error' | 'info' | 'warning' }> = {
  [NotificationType.generationSuccess]: {
    title: 'Your look is ready!',
    type: 'success',
  },
  [NotificationType.generationError]: {
    title: "We're unable to generate your look. Please try again.",
    type: 'error',
  },
  [NotificationType.networkError]: {
    title: 'No internet connection. Please check and try again.',
    type: 'error',
  },
  [NotificationType.uploadError]: {
    title: 'Failed to upload image. Please try again.',
    type: 'error',
  },
};

const showNotification = (type: NotificationType, titleOverride?: string): void => {
  if (!isContextAvailable()) return;

  const config = NotificationConfigs[type];
  getContext().layout.notification.show({
    ...config,
    ...(titleOverride ? { title: titleOverride } : {}),
  });
};

export default showNotification;
